function state() {
  return {
    snackbar: {},
    modal: [],
    errorDialog: {
      show: false,
      message: "",
    },
    pageInfo: {},
    profileMenu: {},
    itemListingOrganisation: {},
    uploadProgress: 0,
    routeViewKey: {},
    pageLoadingFirstTime: null,
    routeOnChanged: null,
  };
}

export default state;
